var Interaction = {
  CLICK: 'click',
  HOVER: 'hover'
};
var interactions = [Interaction.CLICK, Interaction.HOVER];

export { Interaction, interactions };
//# sourceMappingURL=interaction.js.map
